/* Native Shopify data, lazy quick-add, and Focal cart events. */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const currency = document.documentElement.dataset.smCurrency || 'PLN';
  const money = cents => new Intl.NumberFormat('pl-PL', {style:'currency',currency}).format(cents / 100);
  const products = new Map();
  const dialog = document.getElementById('sm-quick-add');
  let product = null, requestNumber = 0, selected = [], activeVariant = null, busy = false;
  const one = selector => dialog?.querySelector(selector);
  const normalizeOptions = p => p.options.map((o,index) => ({name:typeof o === 'string' ? o : o.name, values:[...new Set(p.variants.map(v => v.options[index]))]}));
  const matchVariant = (variants,values) => variants.find(v => v.options.every((value,i) => value === values[i]));

  function openDialog(target) {
    if (!target || !target.showModal) return;
    document.querySelectorAll('dialog[open]').forEach(d => {if (d !== target) d.close();});
    if (!target.open) target.showModal();
    document.documentElement.classList.add('sm-dialog-open');
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-sm-open]');
    if (opener) openDialog(document.getElementById(opener.dataset.smOpen));
    const closer = event.target.closest('[data-sm-close]');
    if (closer) closer.closest('dialog')?.close();
    const quick = event.target.closest('[data-sm-quick-add]');
    if (quick) { event.preventDefault(); loadProduct(quick.dataset.productUrl); }
    const size = event.target.closest('[data-sm-size-guide]');
    if (size) {
      const details = size.closest('.sm-product-info')?.querySelector('.sm-product-accordions details');
      if (details) {details.open = true; const target = details.querySelector('table') || details; target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});}
    }
  });
  document.querySelectorAll('dialog.sm-dialog').forEach(d => {
    d.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('sm-dialog-open');
      if (d === dialog) requestNumber++;
    });
    d.addEventListener('click', event => {
      if (event.target !== d) return;
      const r = d.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) d.close();
    });
  });

  async function loadProduct(url) {
    if (!dialog || busy) return;
    const request = ++requestNumber;
    product = null; activeVariant = null;
    one('[data-sm-quick-body]').hidden = true;
    one('[data-sm-quick-error]').hidden = true;
    one('[data-sm-quick-loading]').hidden = false;
    openDialog(dialog);
    try {
      const productURL = new URL(url,window.location.origin);
      if (productURL.origin !== window.location.origin) throw new Error('Invalid product URL');
      const key = productURL.pathname;
      if (!products.has(key)) {
        const response = await fetch(key + '.js', {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Product request failed');
        products.set(key,await response.json());
      }
      if (request !== requestNumber || !dialog.open) return;
      product = products.get(key);
      product.url = key;
      const first = product.variants.find(v => v.available) || product.variants[0];
      const options = normalizeOptions(product);
      selected = first.options.slice();
      one('[data-sm-quick-title]').textContent = product.title;
      one('[data-sm-quick-link]').href = key;
      one('[data-sm-quick-price]').textContent = money(first.price);
      const image = one('[data-sm-quick-image]');
      const src = first.featured_image?.src || product.featured_image;
      image.hidden = !src;
      if (src) image.src = src;
      image.alt = product.title;
      const optionsContainer = one('[data-sm-quick-options]');
      optionsContainer.replaceChildren();
      if (!(options.length === 1 && options[0].name === 'Title' && options[0].values[0] === 'Default Title')) {
        options.forEach((option,index) => {
          const label = document.createElement('label');
          const name = document.createElement('span');
          name.textContent = /^(size|talla|rozmiar)$/i.test(option.name) ? 'Rozmiar' : /^(colou?r|kolor)$/i.test(option.name) ? 'Kolor' : option.name;
          const select = document.createElement('select');
          select.dataset.optionIndex = String(index);
          select.required = true;
          if (/^(size|talla|rozmiar)$/i.test(option.name) && option.values.length > 1) {
            select.add(new Option('Wybierz rozmiar',''));
            selected[index] = '';
          }
          option.values.forEach(value => select.add(new Option(value,value)));
          select.value = selected[index];
          select.addEventListener('change', () => {
            selected[index] = select.value;
            for (let next = index + 1; next < selected.length; next++) {
              const compatible = product.variants.some(v => v.available && v.options.every((value, i) => i > next || !selected[i] || value === selected[i]));
              if (!compatible) {
                const nextSelect = optionsContainer.querySelector(`[data-option-index="${next}"]`);
                const candidate = product.variants.find(v => v.available && v.options.every((value, i) => i >= next || !selected[i] || value === selected[i]));
                selected[next] = nextSelect?.querySelector('option[value=""]') ? '' : (candidate?.options[next] || '');
                if (nextSelect) nextSelect.value = selected[next];
              }
            }
            updateSelection();
          });
          label.append(name,select); optionsContainer.append(label);
        });
      }
      updateSelection();
      one('[data-sm-quick-loading]').hidden = true;
      one('[data-sm-quick-body]').hidden = false;
      const focusTarget = optionsContainer.querySelector('select') || one('[data-sm-quick-submit]');
      focusTarget.focus({preventScroll:true});
    } catch (error) {
      if (request !== requestNumber) return;
      one('[data-sm-quick-loading]').hidden = true;
      showError('Nie udało się wczytać produktu. Zamknij okno i spróbuj ponownie.');
    }
  }
  function updateSelection() {
    if (!product) return;
    one('[data-sm-quick-error]').hidden = true;
    dialog.querySelectorAll('[data-option-index]').forEach(select => {
      const index = Number(select.dataset.optionIndex);
      [...select.options].forEach(option => {
        if (!option.value) return;
        option.disabled = !product.variants.some(v => v.available && v.options[index] === option.value && selected.every((value,i) => i >= index || !value || v.options[i] === value));
      });
    });
    activeVariant = selected.every(Boolean) ? matchVariant(product.variants,selected) : null;
    const submit = one('[data-sm-quick-submit]');
    submit.disabled = !activeVariant?.available || busy;
    submit.textContent = !selected.every(Boolean) ? 'Wybierz rozmiar' : activeVariant?.available ? 'Dodaj do koszyka' : 'Wariant niedostępny';
    if (activeVariant) {
      one('[data-sm-quick-price]').textContent = money(activeVariant.price);
      one('[data-sm-quick-link]').href = product.url + '?variant=' + activeVariant.id;
      const src = activeVariant.featured_image?.src || product.featured_image;
      if (src) one('[data-sm-quick-image]').src = src;
    }
  }
  function showError(text) {const error=one('[data-sm-quick-error]');error.textContent=text;error.hidden=false;}
  one('[data-sm-quick-form]')?.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !activeVariant?.available) return;
    busy = true;
    const submit = one('[data-sm-quick-submit]');
    submit.disabled = true; submit.textContent = 'Dodawanie…';
    dialog.querySelectorAll('select').forEach(s => s.disabled=true);
    let added = false;
    try {
      const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:activeVariant.id,quantity:1}],sections:['mini-cart'],sections_url:window.location.pathname})});
      const data = await response.json();
      if (!response.ok) {showError(response.status===422?'Ten wariant nie jest już dostępny w wybranej ilości. Wybierz inny wariant.':'Nie udało się dodać produktu. Spróbuj ponownie.');return;}
      added = true;
      const cartResponse = await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      if (typeof data.sections?.['mini-cart'] === 'string' && data.sections['mini-cart'].includes('<cart-drawer')) cart.sections=data.sections;
      dialog.close();
      document.querySelector('[data-sm-live]').textContent='Produkt dodany do koszyka.';
      document.documentElement.dispatchEvent(new CustomEvent('variant:added',{bubbles:true,detail:{variant:data.items?.[0]}}));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart}}));
      if (document.getElementById('mini-cart')) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart,openMiniCart:true}}));
      else window.location.assign(root+'cart');
    } catch (error) {
      if (added) window.location.assign(root+'cart');
      else showError('Nie udało się połączyć ze sklepem. Sprawdź połączenie i spróbuj ponownie.');
    } finally {
      busy = false; dialog.querySelectorAll('select').forEach(s => s.disabled=false);
      submit.disabled = !activeVariant?.available;
      submit.textContent='Dodaj do koszyka';
    }
  });

  function setHeaderHeight() {
    const h=document.querySelector('[data-sm-header]');
    if (h) {document.documentElement.style.setProperty('--sm-header-height',`${h.offsetHeight}px`);document.documentElement.style.setProperty('--header-height',`${h.offsetHeight}px`);document.documentElement.style.setProperty('--header-height-without-bottom-nav',`${h.offsetHeight}px`);}
  }
  setHeaderHeight();
  if ('ResizeObserver' in window) {const h=document.querySelector('[data-sm-header]');if(h)new ResizeObserver(setHeaderHeight).observe(h);}
  function recommendations(scope=document) {
    scope.querySelectorAll('[data-sm-recommendations]:not([data-sm-loaded])').forEach(section => {
      section.dataset.smLoaded='true';
      const load=async()=>{
        try {
          const url=new URL(section.dataset.url,window.location.origin);
          url.searchParams.set('product_id',section.dataset.productId);url.searchParams.set('section_id',section.dataset.sectionId);url.searchParams.set('limit','4');url.searchParams.set('intent','related');
          const response=await fetch(url);
          if(!response.ok)return;
          const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
          const replacement=parsed.getElementById(section.id);
          if(replacement?.querySelector('.sm-card'))section.innerHTML=replacement.innerHTML;
        }catch(error){/* Keep the server-rendered alternatives. */}
      };
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();}},{rootMargin:'400px'});observer.observe(section);}else load();
    });
  }
  recommendations();
  document.addEventListener('shopify:section:load',event=>{setHeaderHeight();recommendations(event.target);});
})();
